// 投稿の目次作成
// =============================
function createIndex() {
  const targetContent = document.querySelector('.knowledge .c-single01__contents');
  if (!targetContent) return;

  const headList = targetContent.querySelectorAll('h2');
  if (headList.length > 1) {
    const list = Array.from(headList);

    //Dom生成
    const divDom = document.createElement('div');
    divDom.classList.add('c-single01__index');
    const pDom = document.createElement('p');
    pDom.textContent = '目次';
    pDom.classList.add('c-single01__index-title');
    const ulDom = document.createElement('ul');
    ulDom.classList.add('c-single01__index-list');

    //li生成
    const fragment = document.createDocumentFragment();

    list.map((head, index) => {
      const text = head.textContent;
      const id = `id_${index + 1}`;

      head.id = id;
      const liDom = document.createElement('li');
      const aDom = document.createElement('a');
      aDom.href = `#${id}`;
      aDom.textContent = text;
      liDom.append(aDom);
      fragment.append(liDom);
    });

    ulDom.append(fragment);

    //create
    divDom.append(pDom);
    divDom.append(ulDom);

    list[0].before(divDom);
  }
}

export { createIndex };